import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Button, 
  Card, 
  Badge, 
  InputGroup,
  FormControl,
} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const WeddingIdeasPage = () => {
  return (
    <Container style={{ paddingTop: "9.5rem", paddingBottom: "2.5rem" }}>
      {/* Header Section */}
      <header className="mb-4">
        <h1 className=" fw-bold">Wedding ideas</h1>
        <p className="text-muted fs-5  mb-3">
          Discover wedding inspiration ideas that'll make your big day fun, special and, of course, as perfectly wedded as you. We've curated exactly the right mix of everything you need.
        </p>
        
        {/* Search Bar */}
        <InputGroup className="mb-3">
          <FormControl
            placeholder="Search for wedding advice..."
            aria-label="Search for wedding advice"
            style={{height:"4.4rem" }}
          />
          <Button variant="danger">Save</Button>
        </InputGroup>
      </header>

      {/* Profile Icons Section */}
      <Row className="mb-4 flex-nowrap overflow-auto gap-2">
        {[
          { name: "Wedding Dresses", img: "/api/placeholder/64/64" },
          { name: "Wedding Rings", img: "/api/placeholder/64/64" },
          { name: "Wedding Venues", img: "/api/placeholder/64/64" },
          { name: "Wedding Themes", img: "/api/placeholder/64/64" },
          { name: "Wedding Reception", img: "/api/placeholder/64/64" },
          { name: "Wedding Planning", img: "/api/placeholder/64/64" },
          { name: "Wedding Colors", img: "/api/placeholder/64/64" },
        ].map((item, index) => (
          <Col key={index} className="text-center" xs="auto">
            <img 
              src={item.img} 
              alt={item.name} 
              className="rounded-circle" 
              width="64" 
              height="64" 
            />
            <p className="small mt-1">{item.name}</p>
          </Col>
        ))}
      </Row>

      {/* Featured Content Grid */}
      <Row className="mb-4 g-3">
        {/* Proposal Post */}
        <Col md={6}>
          <Card className="h-100">
            <Card.Img variant="top" src="/api/placeholder/400/250" alt="Romantic Proposal" />
            <Card.Body>
              <div className="d-flex align-items-center mb-2">
                <Badge bg="primary" className="me-2">125+</Badge>
                <Card.Title as="h5" className="m-0 text-primary fw-bold">
                  Romantic Proposal Lines & Quotes For a Memorable 'Will You Marry Me' Moment
                </Card.Title>
              </div>
              <Card.Text className="small text-muted">
                Whether you're looking for sweet, funny, or heartfelt words to pop the question, these romantic proposal quotes and lines will help you create a memorable moment...
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Grid of Smaller Posts */}
        <Col md={6}>
          <Row className="g-2">
            <Col xs={6}>
              <Card className="h-100">
                <Card.Img variant="top" src="/api/placeholder/200/120" alt="Wedding Trends" />
                <Card.Body className="p-2">
                  <Card.Title as="h6" className="small fw-bold">Wedding Trends 2025: Modern Decoration Trends to Follow</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            
            <Col xs={6}>
              <Card className="h-100">
                <Card.Img variant="top" src="/api/placeholder/200/120" alt="Wedding Couples" />
                <Card.Body className="p-2">
                  <Card.Title as="h6" className="small fw-bold">80+ Dreamy Couple Rings: Which To Select & Gift In 2025</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            
            <Col xs={6} className="mt-2">
              <Card className="h-100">
                <Card.Img variant="top" src="/api/placeholder/200/120" alt="Wedding Colors" />
                <Card.Body className="p-2">
                  <Card.Title as="h6" className="small fw-bold">Best Wedding Colors and Combinations to Design the Perfect Wedding in 2025</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            
            <Col xs={6} className="mt-2">
              <Card className="h-100">
                <Card.Img variant="top" src="/api/placeholder/200/120" alt="Wedding Themes" />
                <Card.Body className="p-2">
                  <Card.Title as="h6" className="small fw-bold">2025 Fun & Festive Themes and Ideas for Your Wedding Inspiration</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Recently Added Section */}
      <div className="recently-added-section mb-4">
        <h2 className="h5 fw-bold mb-3">Recently added to Cosmical Event Planner</h2>
        
        <Row className="g-3">
          {/* Quote Card */}
          <Col md={4}>
            <Card className="h-100">
              <Card.Body className="bg-purple text-white d-flex align-items-center justify-content-center" style={{ backgroundColor: '#8a2be2', minHeight: '180px' }}>
                <Card.Text className="text-center">
                  "Friends are like stars. Even if you can't always see each other, we know we're always thinking of each other."
                </Card.Text>
              </Card.Body>
              <Card.Body>
                <Card.Title as="h6" className="small fw-bold">100+ Best Friend Quotes: To Celebrate Your Special Bond</Card.Title>
                <Card.Text className="small text-muted">
                  These short but powerful quotes for friends you'll love your bridesmaids will perfectly express the...
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Image Card */}
          <Col md={4}>
            <Card className="h-100">
              <Card.Img variant="top" src="/api/placeholder/400/200" alt="Wedding Special" style={{ height: '180px', objectFit: 'cover' }} />
              <Card.Body>
                <Card.Title as="h6" className="small fw-bold">50+ Latest & Stylish Leg Mehndi Designs For Weddings</Card.Title>
                <Card.Text className="small text-muted">
                  With elegant, simple and stunning leg mehndi designs for you to choose from, you're about to...
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Ad Card */}
          <Col md={4}>
            <Card className="h-100 bg-light">
              <Card.Body className="text-center d-flex flex-column justify-content-center" style={{ minHeight: '180px' }}>
                <h3 className="h5 text-primary mb-2">Indeed</h3>
                <Card.Text className="small mb-3">
                  A new way to reach professionals and feature your job in the product recommendations
                </Card.Text>
                <Button variant="primary" size="sm">Sponsor product</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* More Articles Grid */}
      <Row className="g-3 mb-4">
        <Col md={6}>
          <Card className="h-100">
            <Card.Img variant="top" src="/api/placeholder/400/200" alt="Wedding Couple" style={{ height: '180px', objectFit: 'cover' }} />
            <Card.Body>
              <Card.Title as="h6" className="small fw-bold">Wedding Ideas 2025: Best Couple Photos You Need to Bookmark for Your Big Day</Card.Title>
              <Card.Text className="small text-muted">
                Capture your special moments with these amazing couple photo ideas for inspiration. We've curated some of the most popular couple poses...
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={6}>
          <Card className="h-100">
            <Card.Img variant="top" src="/api/placeholder/400/200" alt="Wedding Shoot" style={{ height: '180px', objectFit: 'cover' }} />
            <Card.Body>
              <Card.Title as="h6" className="small fw-bold">Top Wedding Venue Rustic to Elevate Your Pre-Wedding Shoot</Card.Title>
              <Card.Text className="small text-muted">
                Your pre-wedding shoot venue speaks volumes about the wedding plans that you love most...
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

    
    </Container>
  );
};

export default WeddingIdeasPage;